import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { IMAGE, NAVIGATION, CONTACT } from 'src/app/config';
import { ApiService } from 'src/app/api.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
    
})
export class HeaderComponent implements OnInit {
  drop:any;
  message:any="minimum 3 characters are required";
  baseurl = IMAGE;
  searchValue= "";
  activ = 0;
  catall: any;
  active=0;
  values: any;
  profileData:any
  searchkey:string = "";
  notifications:any;
  constructor(private api:ApiService ,private router:Router,private route: ActivatedRoute) {

    this.api.Get(NAVIGATION).then(data => {
      this.catall = data['data'];});
    this.drop=this.api.drop; 
   console.log(this.drop);
      this.profileData = JSON.parse(localStorage.getItem('profileInfo') || "null")
   this.api.Get(CONTACT).then(data=>{
    this.values=data['data'];
    console.log(this.values);
  }).catch(d=>{
    console.log(d);
  });
    router.events.subscribe((val) => {
      this.close();
    });
   
  }
  change(value)
  {
    
    this.searchValue=value.target.value;
  }
  search(type)
  {
    if(this.searchValue.length>=3)
    {
        this.router.navigate(['/search', this.searchValue , type]);
    }
    else{
      this.api.onFail(this.message,'SEARCH');
    }
  }
  popularSearch(value)
  {
    console.log("in search");
    this.router.navigate(['/search', value, 'name']);
  }
  alert()
  {
    if(this.searchValue.length>3)
    {
      return false;
    }
    else
    {
      return true;
    }
  }

  logout()
  {
   
    this.api.setlogin(0);
    this.api.logout();
    this.router.navigate(['/home']);
  }
  mobile(){
    console.log(this.activ);
    if(this.activ==0){
      this.activ = 1;
      setTimeout(()=>{ 
        document.getElementById('sear').focus();
      },250);  
    } else{
      this.activ = 0;
    }
  }

  searchbar(){
    if(this.active==0){
      this.active = 1;
      
     
    } else{
      this.active = 0;
    }
  }

  close(){
    this.activ = 0;
    this.active = 0;
    document.getElementById('close').click();
  }

  ProductsInCart()
{
  let cart=this.api.getCart();
  if(cart)
  {
    return (cart.length);
  }
  else
  {
    return (0);
  }
}
  ngOnInit() {
    this.api.getlogin.subscribe(data => {
      console.log(+data);
      this.drop=data;
      console.log(this.drop);
     });
     this.getNotification();
  }


  getNotification(){
    this.api.Get('notifications').then(data=>{
      this.notifications = data['notifications'];
    }).catch(d=>{
      console.log(d);
    });
  }

}
